import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation
import Header from '../components/Header';
import Hero from '../components/Hero';
import SkillsMatrix from '../components/SkillsMatrix';
import SOCDashboard from '../components/SOCDashboard';
import ToolsRadar from '../components/ToolsRadar'; 
import Certifications from '../components/Certifications';
import Projects from '../components/Projects';
import ThoughtLeadership from '../components/ThoughtLeadership';
import Footer from '../components/Footer';
import { mockData } from '../mockData';
import './Portfolio.css'; 

const Portfolio = () => {
  const [loaded, setLoaded] = useState(false);
  const location = useLocation(); // Get current location state

  useEffect(() => {
    setLoaded(true);

    // --- CHECK FOR SCROLL INSTRUCTION ---
    // If we came from an article page, location.state.scrollToId will exist
    if (location.state && location.state.scrollToId) {
      const targetId = location.state.scrollToId;
      
      // Small timeout ensures the DOM is fully rendered before scrolling
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
        // Clear history state so refresh doesn't scroll again (optional but good practice)
        window.history.replaceState({}, document.title);
      }, 100);
    }
  }, [location]);

  return (
    <div className={`portfolio-container ${loaded ? 'loaded' : ''}`}>
      <Header />
      
      <section id="hero">
        <Hero data={mockData.hero} />
      </section>

      <section id="skills">
        <SkillsMatrix data={mockData.skills} />
      </section>

      <section id="soc">
        <SOCDashboard data={mockData.socDashboard} />
      </section>

      <ToolsRadar />

      <Certifications />

      <Projects data={mockData.projects} />

      <section id="articles">
        <ThoughtLeadership data={mockData.articles} />
      </section>

      <Footer />
    </div>
  );
};

export default Portfolio;